// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IFraudReviewRequiredMetricsResponseDto
 */
export interface IFraudReviewRequiredMetricsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IFraudReviewRequiredMetricsResponseDto
     */
    employee_count?: number;
}

/**
 * Check if a given object implements the IFraudReviewRequiredMetricsResponseDto interface.
 */
export function instanceOfIFraudReviewRequiredMetricsResponseDto(value: object): value is IFraudReviewRequiredMetricsResponseDto {
    return true;
}

export function IFraudReviewRequiredMetricsResponseDtoFromJSON(json: any): IFraudReviewRequiredMetricsResponseDto {
    return IFraudReviewRequiredMetricsResponseDtoFromJSONTyped(json, false);
}

export function IFraudReviewRequiredMetricsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFraudReviewRequiredMetricsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_count': json['employee_count'] == null ? undefined : json['employee_count'],
    };
}

export function IFraudReviewRequiredMetricsResponseDtoToJSON(json: any): IFraudReviewRequiredMetricsResponseDto {
    return IFraudReviewRequiredMetricsResponseDtoToJSONTyped(json, false);
}

export function IFraudReviewRequiredMetricsResponseDtoToJSONTyped(value?: IFraudReviewRequiredMetricsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_count': value['employee_count'],
    };
}

